module.exports = __webpack_public_path__ + "static/pic03-b8b0e88736d2e4c753589895af91d55c.jpg";